import { PrintClient, ScenarioSettings } from "src/types";
import Composite from "./Composite";
import Cover from "./Cover";
import IncomeChart from "./IncomeChart";
import IncomeTable from "./IncomeTable";
import Longevity from "./Longevity";
import Spending from "./Spending";
import SpendingChart from "./SpendingChart";
import BySource from "./BySource";
import ByPerson from "./ByPerson";
import ByTaxType from "./ByTaxType";

interface ReportProps {
  scenario: ScenarioSettings;
  client: PrintClient;
  page: any;
}

export const getReportComponent = (name: string) => {
  switch (name) {
    case "cover":
      return Cover;
    case "incomes":
      return IncomeTable;
    case "by-income-type":
      return BySource;
    case "by-person":
      return ByPerson;
    case "by-tax-status":
      return ByTaxType;
    case "income-chart":
      return IncomeChart;
    case "spending-chart":
      return SpendingChart;
    case "spending":
      return Spending;
    case "composite":
      return Composite;
    case "longevity":
      return Longevity;
    default:
      return () => <div>Page not found: {name}</div>;
  }
};
const Report = ({ scenario, client, page }: ReportProps) => {
  console.log(":page", page.name, client);
  if (!client.userdata) return null;
  const Page = getReportComponent(page.name);
  return <Page client={client} scenario={scenario} />;
};

export default Report;

// <div className="text-2xl mx-auto mb-5">Composite</div>
